// Shared copy: navigation, footer, contact details and small UI strings.
// Arabic text is a first draft and should be reviewed by a native speaker.

export const contact = {
  email: 'contact@shopflexstudios.com',
  supportEmail: 'support@shopflexstudios.com',
  phone: '+20 150 588 4490',
  phoneHref: 'tel:+201505884490',
  whatsapp: 'https://wa.me/201505884490',
  instagram: 'https://www.instagram.com/shopflexstudios/',
  facebook: 'https://www.facebook.com/profile.php?id=61566202610274',
};

export const nav = [
  { to: '/work', label: { en: 'Work', ar: 'أعمالنا' } },
  { to: '/services', label: { en: 'Services', ar: 'خدماتنا' } },
  { to: '/about', label: { en: 'About', ar: 'من نحن' } },
];

export const ui = {
  bookCall: { en: 'Book a call', ar: 'احجز مكالمة' },
  seeWork: { en: 'See our work', ar: 'شاهد أعمالنا' },
  allWork: { en: 'All work', ar: 'كل الأعمال' },
  viewCase: { en: 'View case study', ar: 'شاهد دراسة الحالة' },
  menu: { en: 'Menu', ar: 'القائمة' },
  close: { en: 'Close', ar: 'إغلاق' },
  otherLang: { en: 'العربية', ar: 'English' },
  otherLangLabel: { en: 'View this page in Arabic', ar: 'View this page in English' },
  skip: { en: 'Skip to content', ar: 'انتقل إلى المحتوى' },
  home: { en: 'ShopFlex Studios home', ar: 'الصفحة الرئيسية لـ ShopFlex Studios' },
};

export const footer = {
  ctaTitle: { en: 'Have a brand in mind?', ar: 'لديك فكرة لعلامة تجارية؟' },
  ctaBody: {
    en: 'Tell us about it. We’ll call you back within one working day.',
    ar: 'أخبرنا عنها، وسنتصل بك خلال يوم عمل واحد.',
  },
  explore: { en: 'Explore', ar: 'تصفّح' },
  talk: { en: 'Talk to us', ar: 'تواصل معنا' },
  follow: { en: 'Follow', ar: 'تابعنا' },
  based: { en: 'Based in Egypt, working with brands everywhere.', ar: 'مقرّنا في مصر، ونعمل مع علامات تجارية في كل مكان.' },
  privacy: { en: 'Privacy Policy', ar: 'سياسة الخصوصية' },
  terms: { en: 'Terms of Service', ar: 'شروط الخدمة' },
  rights: { en: 'All rights reserved.', ar: 'جميع الحقوق محفوظة.' },
  general: { en: 'General', ar: 'استفسارات عامة' },
  support: { en: 'Support', ar: 'الدعم الفني' },
};
